import { ifNotDefaultFactory } from './ifNotDefaultFactory.js';
import { toBoolean } from './toBoolean.js';
import { defaultValuesPackages } from './defaultValuesPackages.js';
import { mapPropertyRequired } from './mapPropertyRequired.js';
import { uniq } from '../../../../array/uniq.js';

export function mergeWithSchemaProperty(viewProperty = {}, schemaProperty = {}, options = {}) {
  const { name, forceMaskNumber } = options;
  const ifNotDefault = ifNotDefaultFactory(viewProperty);
  const propertyName = viewProperty.name || viewProperty.model || '';

  ifNotDefault('name', propertyName || schemaProperty.name || '', '');
  ifNotDefault('title', viewProperty.title || schemaProperty.title || propertyName, '');
  ifNotDefault('type', viewProperty.type || schemaProperty.type || 'string', '');
  ifNotDefault('cols', viewProperty.cols || '', '');
  ifNotDefault('placeholder', viewProperty.placeholder || '', '');
  ifNotDefault('pattern', viewProperty.pattern || schemaProperty.pattern, '');
  ifNotDefault('help', viewProperty.help || schemaProperty.description || '', '');
  ifNotDefault('disabled', toBoolean(viewProperty.disabled) || false, false); //isReadOnly
  if (schemaProperty.fixed) {
    viewProperty.readonly = true;
  }
  /** solo para el viejo formBuilder por retrocompatibilidad. El nuevo usa metadata.defaultExpression solo */
  ifNotDefault('fixed', viewProperty.fixed || schemaProperty.fixed, '');
  /** solo para el viejo formBuilder por retrocompatibilidad. El nuevo usa metadata.defaultExpression solo */
  ifNotDefault('default', viewProperty.default || schemaProperty.default, '');

  ifNotDefault('visible', toBoolean(viewProperty.visible || schemaProperty.visible || true), true);
  ifNotDefault('required', toBoolean(mapPropertyRequired(viewProperty, schemaProperty)), false);

  ifNotDefault('min', viewProperty.min || schemaProperty.minItems, '');
  ifNotDefault('max', viewProperty.max || schemaProperty.maxItems, '');

  handleMetadata(viewProperty, schemaProperty, { name, forceMaskNumber: forceMaskNumber && viewProperty.type === 'number' });
}

function handleMetadata(viewProperty, schemaProperty, { name, forceMaskNumber }) {
  // NOTA: Si en el futuro queremos ofrecer el metadata con el dictionary se debería clonar el getViewDictionary(viewProperty.metadata)
  viewProperty.metadata = viewProperty.metadata || {};
  const ifNotDefault = ifNotDefaultFactory(viewProperty.metadata);

  // Common
  ifNotDefault('minLength', viewProperty.metadata.minLength || schemaProperty.minLength, '');
  ifNotDefault('maxLength', viewProperty.metadata.maxLength || schemaProperty.maxLength, '');
  ifNotDefault('min', viewProperty.metadata.min || schemaProperty.min, '');
  ifNotDefault('max', viewProperty.metadata.max || schemaProperty.max, '');

  ifNotDefault('defaultExpression', getDefaultExpression(viewProperty, schemaProperty), '');

  // options: En el merge prevalece view sobre schema
  if (!viewProperty.metadata.options && schemaProperty.select) {
    ifNotDefault(
      'options',
      uniq(schemaProperty.enum).map(value => ({
        value,
        text: schemaProperty.select[value] || '',
      })),
      ''
    );
  }

  // Number
  if (forceMaskNumber && typeof viewProperty.metadata.mask === 'undefined') {
    viewProperty.metadata.mask = 'number';
  }
  ifNotDefault('decimal', viewProperty.metadata.decimal || schemaProperty.fractionDigits, '');

  // Date
  if (schemaProperty.format === 'date-time') {
    ifNotDefault('parse', viewProperty.metadata.parse || "yyyy-MM-dd'T'HH:mm:00", '');
  } else if (viewProperty.type === 'date-time') {
    ifNotDefault('parse', viewProperty.metadata.parse || 'yyyyMMddHHmm', '');
  }
  if (schemaProperty.format === 'date') {
    ifNotDefault('parse', viewProperty.metadata.parse || 'yyyy-MM-dd', '');
  } else if (viewProperty.type === 'date') {
    ifNotDefault('parse', viewProperty.metadata.parse || 'yyyyMMdd', '');
  }
  if (schemaProperty.format === 'time') {
    ifNotDefault('parse', viewProperty.metadata.parse || 'HH:mm:00', '');
  } else if (viewProperty.type === 'time') {
    ifNotDefault('parse', viewProperty.metadata.parse || 'HHmm', '');
  }

  // Package
  if (viewProperty.type === 'packages') {
    defaultValuesPackages(viewProperty, name);
  }
}

function getDefaultExpression(viewProperty, schemaProperty) {
  if (viewProperty.metadata.defaultExpression) {
    return viewProperty.metadata.defaultExpression;
  }

  /** devuelve undefined si todos son undefined, y maneja bien 0 o false ... */
  return JSON.stringify(schemaProperty.fixed ?? viewProperty.default ?? schemaProperty.default);
}
